import React from 'react';

const Calculator: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 0.666656H37.6667V39.3333H4V0.666656ZM6 2.66666V37.3333H35.6667V2.66666H6Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6667 9H31.0001V17.6667H10.6667V9ZM12.6667 11V15.6667H29.0001V11H12.6667Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6667 22.3333H14.3334V24.3333H10.6667V22.3333Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 22.3333H22.6667V24.3333H19V22.3333Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6667 29H14.3334V31H10.6667V29Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 29H22.6667V31H19V29Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.3333 22.3333H30.9999V24.3333H27.3333V22.3333Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.3333 29H30.9999V31H27.3333V29Z"
      />
    </svg>
  );
};

export default Calculator;
